import useSWR, { type SWRConfiguration } from "swr";
import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { GetByIdVisitResponse } from "./type";

async function getVisitById(id: string): Promise<GetByIdVisitResponse> {
  const response = await apiClient.get<GetByIdVisitResponse>(
    apiPaths.visits.getById(id),
  );
  return response.data;
}

export function useGetVisitById(
  visitId: string | null,
  options?: SWRConfiguration,
) {
  return useSWR(
    visitId ? [`fetch-visit-${visitId}`] : null,
    () => getVisitById(visitId!),
    options,
  );
}
